import systemIcons from './system';
// Domain-specific icons
import dashboardsIcons from './dashboards';
import highlightsIcons from './highlights';
import omnisearchIcons from './omnisearch';
import pageInsightsIcons from './page-insights';
import personasIcons from './personas';
import playbackIcons from './playback';
import segmentsIcons from './segments';
import settingsIcons from './settings';
import pageIcons from './pages';
import grammarIcons from './grammar';

/**
 * Deprecated icon registry for lookup by name
 * @deprecated
 */
const iconRegistry = {
  ...systemIcons,
  ...dashboardsIcons,
  ...highlightsIcons,
  ...omnisearchIcons,
  ...pageInsightsIcons,
  ...pageIcons,
  ...personasIcons,
  ...playbackIcons,
  ...segmentsIcons,
  ...settingsIcons,
  ...grammarIcons,
};

/**
 * Deprecated icon names union type
 * @deprecated
 */
export type IconName = keyof typeof iconRegistry

export default iconRegistry;

export * from './system';
